import { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { FaEdit, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import { getUserRole } from "../roleCrypto";

const API = process.env.REACT_APP_API_URL;
const userRole = getUserRole();

function Services() {
  useEffect(() => {
    document.title = "Services | Admin Panel";
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const [services, setServices] = useState([]);

  // modal states
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  // form state
  const [serviceName, setServiceName] = useState("");
  const [price, setPrice] = useState("");
  const [editId, setEditId] = useState(null);

  // search
  const [search, setSearch] = useState("");

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  useEffect(() => {
    fetchServices();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

const fetchServices = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.get(`${API}/services`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setServices(res.data);

  } catch (err) {
    console.log(err);

    if (err.response?.status === 401) {
       toast.error("Token not valid / expired");
       localStorage.removeItem("token");
       window.location.href = "/login";
    }
  }
};

  // filtered data
  const filteredServices = services.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  // pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentServices = filteredServices.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPages = Math.ceil(filteredServices.length / itemsPerPage);

  const handleSubmit = async (e) => {
    e.preventDefault();

  try {
    const token = localStorage.getItem("token");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    if (isEdit && editId) {
      await axios.put(
        `${API}/services/${editId}`,
        {
          name: serviceName,
          price: price,
        },
        config
      );

      toast.success("Service updated successfully 🎉");
    } else {
      await axios.post(
        `${API}/services`,
        {
          name: serviceName,
          price: price,
        },
        config
      );

      toast.success("Service added successfully 🚀");
    }
      fetchServices();
      closeModal();
    } catch (err) {
      console.log(err);

      if (err.response) {
        if (err.response?.status === 401) {
            toast.error("Unauthorized token");
            localStorage.removeItem("token");
            window.location.href = "/login";
          }
        if (err.response.data.message) {
          toast.error(err.response.data.message);
        } else if (err.response.data.errors) {
          const errors = err.response.data.errors;

          Object.values(errors).forEach((messages) => {
            toast.error(messages[0]);
          });
        } else {
          toast.error("Validation failed ❌");
        }
      } else {
        toast.error("Server not responding ❌");
      }
    }
  };

const handleDelete = async (id) => {
  const confirmDelete = window.confirm(
    "Are you sure you want to delete this service?"
  );

  if (!confirmDelete) return;

  try {
    const token = localStorage.getItem("token");

    await axios.delete(`${API}/services/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    toast.success("Service deleted successfully ❌");
    fetchServices();

  } catch (err) {
    console.log(err);

    if (err.response) {
      const status = err.response.status;
      const message = err.response.data?.message;

      if (status === 401) {
        toast.error("Unauthorized token ❌");
        localStorage.removeItem("token");
        window.location.href = "/login";
      } else if (status === 422) {
        // 👇 your validation message
        toast.error(message || "Cannot delete this service");
      } else if (status === 404) {
        toast.error(message || "Service not found");
      } else {
        toast.error(message || "Delete failed");
      }
    } else {
      toast.error("Server not responding");
    }
  }
};

  const handleEdit = (item) => {
    setServiceName(item.name);
    setPrice(item.price);
    setEditId(item.id);
    setIsEdit(true);
    setShowModal(true);
  };

  const openAddModal = () => {
    setServiceName("");
    setPrice("");
    setIsEdit(false);
    setShowModal(true);
  };

  const closeModal = () => {
    setServiceName("");
    setPrice("");
    setEditId(null);
    setIsEdit(false);
    setShowModal(false);
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar isOpen={isOpen} toggleSidebar={() => setIsOpen(!isOpen)} />

      {/* Main */}
      <div className="flex-1 flex flex-col">
        <Header toggleSidebar={() => setIsOpen(!isOpen)} />

        <main className="p-6">
          {/* TOP BAR */}
          <div className="flex flex-col md:flex-row justify-between gap-4 mb-6">
            <h2 className="text-2xl font-bold">Services</h2>

            <div className="flex gap-3">
              <input
                type="text"
                placeholder="Search services..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="px-4 py-2 border rounded-lg w-full md:w-64"
              />

              <button
                onClick={openAddModal}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
              >
                + Add
              </button>
            </div>
          </div>

          {/* CARDS */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {currentServices.map((item) => (
              <div
                key={item.id}
                className="bg-white rounded-2xl shadow hover:shadow-xl transition p-5"
              >
                <h3 className="text-lg font-bold text-gray-800">
                  {item.name}
                </h3>

                <p className="text-gray-500 mt-1">
                  Price:{" "}
                  <span className="font-bold">AED {item.price}</span>
                </p>

                <div className="flex justify-between mt-5">
                  {userRole !== "subadmin" && (
                  <button
                    onClick={() => handleEdit(item)}
                    className="text-blue-600 hover:text-blue-800 flex items-center gap-2"
                  >
                    <FaEdit /> Edit
                  </button>
                  )}
                 {userRole !== "subadmin" && (
                  <button
                    onClick={() => handleDelete(item.id)}
                    className="text-red-600 hover:text-red-800 flex items-center gap-2"
                  >
                    <FaTrash /> Delete
                  </button>
                 )}
                </div>
              </div>
            ))}
          </div>

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="flex justify-center mt-8 gap-2">
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.max(prev - 1, 1))
                }
                className="px-3 py-1 bg-white border rounded-lg"
              >
                Prev
              </button>

              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentPage(index + 1)}
                  className={`px-3 py-1 border rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-600 text-white"
                      : "bg-white"
                  }`}
                >
                  {index + 1}
                </button>
              ))}

              <button
                onClick={() =>
                  setCurrentPage((prev) =>
                    Math.min(prev + 1, totalPages)
                  )
                }
                className="px-3 py-1 bg-white border rounded-lg"
              >
                Next
              </button>
            </div>
          )}
        </main>
      </div>

      {/* MODAL */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md p-6 rounded-2xl shadow-2xl">
            <h2 className="text-xl font-bold mb-4">
              {isEdit ? "Update Service" : "Add Service"}
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="text"
                placeholder="Service Name"
                value={serviceName}
                onChange={(e) => setServiceName(e.target.value)}
                className="w-full border p-3 rounded-lg"
                required
              />

              <input
                type="number"
                placeholder="Price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                className="w-full border p-3 rounded-lg"
                required
              />

              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={closeModal}
                  className="w-full bg-gray-300 py-2 rounded-lg"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="w-full bg-blue-600 text-white py-2 rounded-lg"
                >
                  {isEdit ? "Update" : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Services;